//PAQUETERIAS
import { useEffect, useState, useMemo } from "react";
import Box from "@mui/material/Box";
import dayjs from 'dayjs';

//COMPONENTES
import { date_current, previous_date } from "../../../main_components/date/date";
import MODAL_TABLE from "../../../main_components/modal/modal_Table";
import { BREADCRUMBS } from "../../../main_components/pagination/breadcrumbs";
import { refresh_token } from "../../../main_components/tokens/tokenrefresh";
//ESTILOS
import "../../expense.css";
//IMAGENES/ICONOS


import { MaterialReactTable } from 'material-react-table';
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import RENDER_TOOLBAR_INTERNAL_ACTIONS from "../../../main_components/methods_v2/export";
import SEARCH_FILTERS from "./detail/shearch_filter";
import { expenses_group_get, expenses_group_delete } from "../../../services/expenses/group";
import DeleteIcon from "@mui/icons-material/Delete";

import ContentPasteSearchIcon from '@mui/icons-material/ContentPasteSearch';
import { findInObjectDisplayRole } from "../../../Content/verify_role";
const CONSULT_GROUP_EXPENSE = () => {

  const [data, setData] = useState([]);
  const [ff, setff] = useState(dayjs(date_current));
  const [fi, setfi] = useState(dayjs(previous_date));
  const [rowSelection, setRowSelection] = useState({});
  const [modalT, setmodalT] = useState(false);
  const [total_rows, settotal_rows] = useState("");

  const handleSubmit = async (event) => {
    event?.preventDefault();
    setmodalT(true);

    try {
      var rf_token = await refresh_token();
      if (rf_token === true) {
        try {
          var dt = await expenses_group_get(fi.format('YYYY-MM-DD'), ff.format('YYYY-MM-DD'));
          const data = dt?.data?.sort((a, b) => a.id < b.id ? 1 : a.id > b.id ? -1 : 0);;
          setData(data);
          setmodalT(false);
        } catch (err) {
          console.log("error", err);
          setData([]);
          setmodalT(false);
        }
      } else {
      }
    } catch (err) {
      console.log(err);
    }
  };

  const handleReconsulta = (reconsultar) => {
    if (reconsultar === true) {
      handleSubmit();
    } else {
      console.log("no se reconsulto");
    }
  };

  const handle_delete_expense_group = async (id) => {
    setmodalT(true)
    try {
      await expenses_group_delete(id);
      handleReconsulta(true);

    } catch (err) {
      alert("Error.," + err.response?.data?.errorMessage.es);

      console.log(err);
    } finally {
      setmodalT(false)

    }
  }


  const handleStateChange = (newState) => {
    const filteredRowsCount = newState.filteredRowModel
    settotal_rows(filteredRowsCount);
  };



  const ConsultDetailGrupExpense = async (id, concept) => {
    sessionStorage.setItem("IdGrupExpense", id);
    sessionStorage.setItem("nameConceptExpense", concept);
    window.location = "/expense_group_detail";
  };


  useEffect(() => {
    handleSubmit();
  }, []);

  const columns = useMemo(
    () => [
      {
        header: "Ac.",
        id: "ac",
        enableFilters: false,
        enableEditing: false,
        enableRowOrdering: false,
        enableGrouping: false,
        enableColumnDragging: false,
        enableColumnActions: false,
        enableFilterMatchHighlighting: false,
        enableColumnFilterModes: false,
        enableColumnFilter: false,
        enableSorting: false,
        size: 80,
        accessorFn: (d) => {
          return (
            <div>
              <span title="Consultar Detalles">
                <ContentPasteSearchIcon className="icons_general_save" onClick={() => ConsultDetailGrupExpense(d.id, d.concept)}></ContentPasteSearchIcon>
              </span>
              <span title="Eliminar Gasto Agrupado"
                style={{ cursor: "pointer", display: findInObjectDisplayRole(["PU:GE", "PU:GE3"]) }}
              >
                <DeleteIcon className="icons_general_delete" onClick={() => handle_delete_expense_group(d.id)}></DeleteIcon>
              </span>
            </div>
          );
        }
      },

      {
        id: "id",
        header: "No.",
        accessorKey: "id",
        size: 130
      },
      {
        id: "date",
        header: "Fecha",
        accessorKey: "date",
        size: 150
      },
      {
        id: "concept",
        header: "Concepto",
        accessorKey: "concept",
        size: 250
      },
      {
        id: "payment",
        header: "Pago",
        accessorKey: "payment",
        size: 300
      },
      {
        id: "total",
        header: "Total",
        accessorKey: "total",
        Cell: ({ cell }) => (
          <Box
            component="span"
            sx={(theme) => ({
              backgroundColor: theme.palette.success.dark,
              borderRadius: '0.25rem',
              color: '#fff',
              maxWidth: '9ch',
              p: '0.25rem',
            })}
          >
            {cell.getValue()?.toLocaleString?.('en-US', {
              style: 'currency',
              currency: 'USD',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}
          </Box>
        ),
        muiTableBodyCellProps: {
          align: 'right',
        },
        muiTableFooterCellProps: {
          align: 'right',
        },
      },
      {
        id: "user_name",
        header: "Usuario",
        accessorKey: "user_name",
        size: 300
      },
    ],
    []
  );

  const update_identifiers =
    [
      { id: 'string' },
      { date: 'string' },
      { concept: 'string' },
      { payment: 'string' },
      { total: 'string' },
      { user_name: 'string' }
    ];


  return (
    <div >
      <MODAL_TABLE
        open={true}
        message={""}
        modalGeneral={false}
        modalT={modalT}
      ></MODAL_TABLE>


      <BREADCRUMBS niveles={
        [
          { label: "REPORTE DE GASTOS", path: "/expense_report" },
          { label: "REPORTE DE GASTOS AGRUPADOS", path: null },

        ]
      }
        cards_dashboard={true}
        total_rows={total_rows !== "" ? total_rows : 0}
        filter_row={total_rows !== "" ? total_rows?.getFilteredRowModel()?.rows?.length : 0}
        visibility_row={total_rows !== "" ? total_rows?.getPaginationRowModel()?.rows?.length : 0}
        total={data?.length}
      ></BREADCRUMBS>


      <div className="new_table_v2">
        <MaterialReactTable
          columns={columns}
          data={data}
          enableGrouping
          enableFacetedValues
          enableStickyHeader
          enableStickyFooter
          enableRowPinning
          enableColumnFilterModes
          onStateChange={handleStateChange}
          enableRowSelection
          getRowId={(row) => row?.id}
          onRowSelectionChange={setRowSelection}
          enableTooltips={false}
          localization={MRT_Localization_ES}
          state={{ rowSelection }}
          enableColumnResizing
          enableColumnPinning
          enableColumnOrdering
          enableExpandAll={false}
          enableColumnDragging={false}
          initialState={{ showGlobalFilter: true, showColumnFilters: true }}
          muiCircularProgressProps={{ color: 'secondary', thickness: 5, size: 55 }}
          muiSkeletonProps={{ animation: 'pulse', height: 28 }}
          rowVirtualizerInstanceRef
          rowVirtualizerOptions={{ overscan: 5 }}
          columnVirtualizerOptions={{ overscan: 2 }}
          muiTableContainerProps={{ sx: { maxHeight: '69vh', '@media (max-height: 810px)': { maxHeight: '65vh' } } }}
          positionToolbarAlertBanner="bottom"
          paginationDisplayMode='pages'
          rowPinningDisplayMode='sticky'
          layoutMode="grid"
          muiTableHeadCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
          muiTableBodyCellProps={{ sx: { flex: '0 0 auto', whiteSpace: "normal !important" } }}
          muiPaginationProps={{ color: 'primary', shape: 'rounded', variant: 'variant', }}
          displayColumnDefOptions={{
            'mrt-row-pin': {
              enableHiding: true,
            },
            'mrt-row-actions': {
              enableHiding: true,
            },
            'mrt-row-expand': {
              enableHiding: true,
            },
            'mrt-row-select': {
              enableHiding: true,
            }
          }}
          muiTableBodyRowDragHandleProps={({ table }) => ({
            onDragEnd: () => {
              const { draggingRow, hoveredRow } = table.getState();
              if (hoveredRow && draggingRow) {
                data.splice(
                  hoveredRow.index,
                  0,
                  data.splice(draggingRow.index, 1)[0],
                );
                setData([...data]);
              }
            },
          })}
          muiTableBodyRowProps={
            ({ row, table }) => {
              settotal_rows(table);
              const { density } = table.getState();
              return {
                sx: {
                  height: row.getIsPinned()
                    ? `${density === 'compact' ? 30 : density === 'comfortable' ? 35 : 69
                    }px`
                    : undefined,
                },
              };
            }
          }
          renderTopToolbarCustomActions={({ }) => (
            <SEARCH_FILTERS
              fi={fi}
              setfi={setfi}
              ff={ff}
              setff={setff}
              handle_get_sales={handleSubmit}
            ></SEARCH_FILTERS>
          )}
          renderToolbarInternalActions={({ table }) => (
            <RENDER_TOOLBAR_INTERNAL_ACTIONS
              table={table}
              file_name={"Reporte de Gastos"}
              update_identifiers={update_identifiers}
              settotal_rows={settotal_rows}
            />
          )
          }
        />
      </div>
    </div>
  );
};

export default CONSULT_GROUP_EXPENSE;
